import { connectHook } from 'app/common/components/connect-hook';
import { Link } from './link';
import { useLink } from './link-hook';

export default connectHook(Link, useLink);
